var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Illustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 561.001,
    height: 400.658,
    viewBox: "0 0 561.001 400.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_404_Illustration",
    "data-name": "404 Illustration",
    transform: "translate(-0.04)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 128.002,
    height: 77.318,
    rx: 3.21,
    transform: "translate(162.799 23.08)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x2: 128.002,
    transform: "translate(162.799 37.085)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 2.048,
    cy: 2.048,
    r: 2.048,
    transform: "translate(169.016 28.117)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2886",
    "data-name": "Path 2886",
    d: "M175.647,29.249a2.069,2.069,0,1,1-2.069-2.069A2.069,2.069,0,0,1,175.647,29.249Z",
    transform: "translate(5.874 0.917)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2887",
    "data-name": "Path 2887",
    d: "M183.787,29.249a2.069,2.069,0,1,1-2.069-2.069A2.069,2.069,0,0,1,183.787,29.249Z",
    transform: "translate(6.154 0.917)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 40.857,
    height: 40.857,
    rx: 5.12,
    transform: "translate(90.353 67.63)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 11.699,
    cy: 11.699,
    r: 11.699,
    transform: "translate(99.083 76.36)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x1: 16.529,
    y2: 16.519,
    transform: "translate(102.155 79.794)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2888",
    "data-name": "Path 2888",
    d: "M393.73,99.188l-8.471-8.782H254.837A11.047,11.047,0,0,1,243.79,79.359V11.547A11.047,11.047,0,0,1,254.837.5H385.849A11.047,11.047,0,0,1,396.9,11.547V97.916a1.841,1.841,0,0,1-3.165,1.272Z",
    transform: "translate(8.357)",
    fill: "#fff",
    stroke: "#c0ccd8",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2889",
    "data-name": "Path 2889",
    d: "M295.782,59.475h-5.606v9.868H276.585V59.475H256.27V49.369L277.454,18.39h12.723v30.8h5.606Zm-19.2-10.282V43.277c0-1.117,0-2.617.124-4.52a29.1,29.1,0,0,1,.186-2.979h-.383a37.391,37.391,0,0,1-2.679,5.027l-5.648,8.389Z",
    transform: "translate(8.786 0.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2890",
    "data-name": "Path 2890",
    d: "M336.742,43.963q0,13.509-4.53,19.808T318.341,70.06q-9.123,0-13.767-6.568T299.94,43.963q0-13.591,4.53-19.932t13.871-6.351q9.092,0,13.747,6.61T336.742,43.963Zm-23.108,0q0,8.637,1.086,11.885t3.62,3.238c1.717,0,2.938-1.117,3.641-3.341s1.034-6.206,1.034-11.781-.362-9.6-1.034-11.864-1.934-3.4-3.631-3.4-2.907,1.1-3.62,3.279S313.635,38.15,313.635,43.963Z",
    transform: "translate(10.286 0.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2891",
    "data-name": "Path 2891",
    d: "M380.642,59.475h-5.606v9.868H361.445V59.475H341.13V49.369L362.314,18.39h12.723v30.8h5.606Zm-19.2-10.282V43.277c0-1.117,0-2.617.124-4.52a29.088,29.088,0,0,1,.186-2.979h-.383a37.388,37.388,0,0,1-2.679,5.027l-5.648,8.389Z",
    transform: "translate(11.701 0.615)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 40.857,
    height: 40.857,
    rx: 5.12,
    transform: "translate(519.683 186.591)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2892",
    "data-name": "Path 2892",
    d: "M535.838,212.074a1.314,1.314,0,0,1-.5.083H509.99a1.479,1.479,0,0,1-1.293-.745,1.459,1.459,0,0,1,0-1.479l12.671-21.908a1.5,1.5,0,0,1,1.293-.745,1.479,1.479,0,0,1,1.283.745l12.692,21.959a1.531,1.531,0,0,1,0,1.489,1.49,1.49,0,0,1-.8.6Zm-25.156-1.8h23.966L522.66,189.525Z",
    transform: "translate(17.452 6.417)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2893",
    "data-name": "Path 2893",
    d: "M522.237,205.654h0a.89.89,0,0,1-.89-.848l-.517-8.647a1.4,1.4,0,0,1,1.407-1.469h0a1.407,1.407,0,0,1,1.407,1.469l-.507,8.637a.89.89,0,0,1-.9.859Z",
    transform: "translate(17.875 6.672)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2894",
    "data-name": "Path 2894",
    d: "M523.141,207.34a.921.921,0,1,1-.921-.91.91.91,0,0,1,.921.91Z",
    transform: "translate(17.891 7.075)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2895",
    "data-name": "Path 2895",
    d: "M5.153,149.407a2.3,2.3,0,1,1-.673-1.634A2.307,2.307,0,0,1,5.153,149.407Z",
    transform: "translate(0 5.037)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2896",
    "data-name": "Path 2896",
    d: "M379.483,268.217a2.307,2.307,0,1,1-2.307-2.307,2.307,2.307,0,0,1,2.307,2.307Z",
    transform: "translate(12.861 9.119)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2897",
    "data-name": "Path 2897",
    d: "M532.613,85.227a2.307,2.307,0,1,1-2.307-2.307,2.307,2.307,0,0,1,2.307,2.307Z",
    transform: "translate(18.122 2.832)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2898",
    "data-name": "Path 2898",
    d: "M412.333,16.307A2.307,2.307,0,1,1,410.078,14,2.307,2.307,0,0,1,412.333,16.307Z",
    transform: "translate(13.989 0.464)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    y2: 7.137,
    transform: "translate(546.122 163.442)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x1: 7.137,
    transform: "translate(542.553 167.011)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y2: 7.137,
    transform: "translate(359.544 300.939)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x1: 7.147,
    transform: "translate(355.966 304.508)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    y2: 7.137,
    transform: "translate(208.59 3.603)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x1: 7.137,
    transform: "translate(205.022 7.172)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    y2: 7.137,
    transform: "translate(48.813 72.595)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x1: 7.137,
    transform: "translate(45.245 76.163)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    y2: 7.137,
    transform: "translate(37.198 236.923)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x1: 7.137,
    transform: "translate(33.629 240.491)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    y2: 7.137,
    transform: "translate(441.786 44.015)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x1: 7.137,
    transform: "translate(438.218 47.584)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2899",
    "data-name": "Path 2899",
    d: "M89.766,189.93H18.4a2.255,2.255,0,0,1-2.265-2.255h0A2.255,2.255,0,0,1,18.4,185.42H89.766a2.255,2.255,0,0,1,2.255,2.255h0A2.255,2.255,0,0,1,89.766,189.93Z",
    transform: "translate(0.536 6.353)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2900",
    "data-name": "Path 2900",
    d: "M496.327,134.79H424.9a2.245,2.245,0,0,1-2.255-2.255h0a2.245,2.245,0,0,1,2.255-2.255h71.422a2.244,2.244,0,0,1,2.255,2.255h0a2.244,2.244,0,0,1-2.255,2.255Z",
    transform: "translate(14.502 4.459)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2901",
    "data-name": "Path 2901",
    d: "M504.915,149.405H478.5a1.127,1.127,0,0,1-1.127-1.138h0a1.127,1.127,0,0,1,1.127-1.127h26.417a1.127,1.127,0,0,1,1.127,1.127h0a1.127,1.127,0,0,1-1.127,1.138Z",
    transform: "translate(16.382 5.038)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2902",
    "data-name": "Path 2902",
    d: "M437.355,97.365h-26.4a1.127,1.127,0,0,1-1.138-1.127h0a1.128,1.128,0,0,1,1.138-1.127h26.4a1.127,1.127,0,0,1,1.127,1.127h0A1.127,1.127,0,0,1,437.355,97.365Z",
    transform: "translate(14.061 3.25)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2903",
    "data-name": "Path 2903",
    d: "M62.359,170.555H42.169A1.127,1.127,0,0,1,41,169.427h0a1.117,1.117,0,0,1,1.127-1.127H62.359a1.127,1.127,0,0,1,1.138,1.127h0a1.127,1.127,0,0,1-1.138,1.127Z",
    transform: "translate(1.39 5.765)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 29.521,
    height: 29.521,
    rx: 3.7,
    transform: "translate(497.093 76.629) rotate(180)",
    fill: "none",
    stroke: "#c0ccd8",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2904",
    "data-name": "Path 2904",
    d: "M470.759,58.854l-.517,2.534h2.824v2.255h-3.248l-.848,4.437h-2.4l.848-4.437h-3.1l-.827,4.437H461.14l.807-4.437H459.34V61.388h3.031l.517-2.534h-2.751V56.568h3.155l.838-4.448h2.4l-.848,4.448h3.1l.848-4.448h2.348l-.848,4.448h2.617v2.286Zm-6.02,2.534h3.1l.507-2.534h-3.1Z",
    transform: "translate(15.763 1.773)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2905",
    "data-name": "Path 2905",
    d: "M229.79,276.058,209.1,140.05H115.7l22.383,144.127A19.539,19.539,0,0,0,157.8,300.82H314.814l1.158-13.209H243.443A13.519,13.519,0,0,1,229.79,276.058Z",
    transform: "translate(3.956 4.794)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    d: "M141.654,276.058l-19.963-130.97a5.9,5.9,0,0,0-5.948-5.037h-.186a7.24,7.24,0,0,0-7.1,8.12l21.132,136.007A19.539,19.539,0,0,0,149.36,300.82H250.51l1.158-13.209H155.287A13.519,13.519,0,0,1,141.654,276.058Z",
    transform: "translate(3.706 4.794)",
    fill: "#717a91"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    y2: 74.236,
    transform: "translate(208.59 305.614)",
    fill: "none",
    stroke: "#544943",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M161.44,373.808h0A6.558,6.558,0,0,1,168,367.25h70.119a6.558,6.558,0,0,1,6.558,6.558h0",
    transform: "translate(5.528 12.6)",
    fill: "none",
    stroke: "#544943",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M194.74,373.808h0a6.558,6.558,0,0,1,6.558-6.558",
    transform: "translate(6.672 12.6)",
    fill: "none",
    stroke: "#544943",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M168.28,380.22a6.62,6.62,0,1,1-6.62-6.62,6.62,6.62,0,0,1,6.62,6.62Z",
    transform: "translate(5.308 12.818)",
    fill: "#717a91"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2480",
    "data-name": "Group 2480",
    transform: "translate(164.537 390.608)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M163.951,380.081a2.431,2.431,0,1,1-2.431-2.431,2.431,2.431,0,0,1,2.431,2.431Z",
    transform: "translate(-159.09 -377.65)",
    fill: "#8e9db2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M201.58,380.22a6.62,6.62,0,1,1-6.62-6.62A6.62,6.62,0,0,1,201.58,380.22Z",
    transform: "translate(6.452 12.818)",
    fill: "#717a91"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2481",
    "data-name": "Group 2481",
    transform: "translate(198.981 390.608)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M197.251,380.081a2.431,2.431,0,1,1-2.431-2.431A2.431,2.431,0,0,1,197.251,380.081Z",
    transform: "translate(-192.39 -377.65)",
    fill: "#8e9db2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M248.75,380.22a6.62,6.62,0,1,1-6.62-6.62A6.62,6.62,0,0,1,248.75,380.22Z",
    transform: "translate(8.073 12.818)",
    fill: "#717a91"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2482",
    "data-name": "Group 2482",
    transform: "translate(247.772 390.608)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M244.421,380.081a2.431,2.431,0,1,1-2.431-2.431,2.431,2.431,0,0,1,2.431,2.431Z",
    transform: "translate(-239.56 -377.65)",
    fill: "#8e9db2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M272.25,155.334,295.926,120l7.334,1.531c-5.606,18.877-9.309,26.345-9.309,26.345",
    transform: "translate(9.335 4.106)",
    fill: "#ffcbbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M298.79,127.784l3.775-5.854s7.023-1.624,9.578-2.917a10.623,10.623,0,0,0,4.965-5.565c.538-1.5.31-5.885-.331-5.958-1.51-.165-4.52,5.461-5.937,5.792s-5.979,0-8.492.321a8.275,8.275,0,0,0-6.02,4.52l-3.868,7.013",
    transform: "translate(10.029 3.676)",
    fill: "#ffcbbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M287.21,130.18l4.158-6.02,10.747,4.82-3.413,9.154",
    transform: "translate(9.849 4.249)",
    fill: "#e6e8ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2918",
    "data-name": "Path 2918",
    d: "M203.71,117.868s17.522-8.058,32.965,5.679,25.859,26.49,31.558,30.617l23.252-26.769,12.992,6.092c-3.424,19.384-13.033,50.28-36.565,53.466-25.455,3.444-62.775-27.928-62.775-27.928",
    transform: "translate(6.98 3.952)",
    fill: "#b9b5b2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y1: 8.895,
    x2: 7.551,
    transform: "translate(267.663 158.115)",
    fill: "none",
    stroke: "#846a6a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2919",
    "data-name": "Path 2919",
    d: "M294.808,375.58l-1.965,7.561a2.907,2.907,0,0,0,2.8,3.631h22.9a2.493,2.493,0,0,0,2.493-2.482h0a2.482,2.482,0,0,0-1.727-2.369l-15.66-6.32",
    transform: "translate(10.039 12.886)",
    fill: "#173789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2920",
    "data-name": "Path 2920",
    d: "M282.017,261.44c-3.651,38.426,13.2,118.061,13.2,118.061s4,4.841,8.844,0c0,0,4.065-75.922,8.347-110.066",
    transform: "translate(9.653 8.965)",
    fill: "#ffcbbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M230.654,217.93l26.273,13.778v.269s53.642-3.6,61.751,15.515c12.7,30,14.864,127.505,14.864,127.505H294.288s-14.615-81.911-19.653-86.886-25.59-4.624-63.458-4.624c-42.543,0-21.784-54.821-5.937-59.558",
    transform: "translate(6.371 7.47)",
    fill: "#fca32d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M295.982,372.963s-11.709-84.517-20.242-90.723c-10.468-7.561-59.91-2.617-59.91-2.617",
    transform: "translate(7.397 9.535)",
    fill: "none",
    stroke: "#ce680d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M215.228,375.58l-1.965,7.561a2.907,2.907,0,0,0,2.834,3.631H239a2.493,2.493,0,0,0,2.493-2.5h0a2.482,2.482,0,0,0-1.727-2.369l-15.66-6.32",
    transform: "translate(7.305 12.886)",
    fill: "#173789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M218.977,261.44C215.315,299.866,215.16,379.5,215.16,379.5s4,4.841,8.844,0c0,0,13.778-75.922,18.06-110.066",
    transform: "translate(7.374 8.965)",
    fill: "#ffcbbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M185.476,230.119s68.94,1.117,77.959,22c11.088,25.693-7.241,123.088-7.241,123.088H214.686V288.115a3.1,3.1,0,0,0-3.01-3.155c-5.751.155-18.618.155-34.9.155-42.543,0-21.773-66.2-5.937-70.915",
    transform: "translate(5.189 7.342)",
    fill: "#ffb548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M184.35,229.59s68.94,1.117,77.959,22c3,6.961,4.562,18.815,3.765,32.944",
    transform: "translate(6.315 7.871)",
    fill: "none",
    stroke: "#ce680d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M220.272,375.157s.424-87.424-1.583-92.058c-2.793-6.485-12.319-3.3-34.413-3.3-42.543,0-25.218-60.9-9.371-65.609",
    transform: "translate(5.396 7.342)",
    fill: "none",
    stroke: "#ed841b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M158.74,240.581s21.846.528,25.156-2.772,0-18.318,0-18.318",
    transform: "translate(5.435 7.524)",
    fill: "none",
    stroke: "#ed841b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    d: "M158.22,243.422s24.938.528,28.714-2.793,0-18.329,0-18.329",
    transform: "translate(5.417 7.62)",
    fill: "none",
    stroke: "#ed841b",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "3 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M154.206,142.577s-5.234,92.989,2.689,92.989,96.019-.269,101.181-.269-6.92-79.521-24.318-96.319c0,0-25.807-28-37.175-25.321S154.206,142.577,154.206,142.577Z",
    transform: "translate(5.221 3.881)",
    fill: "#b9b5b2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x1: 10.943,
    y1: 44.839,
    transform: "translate(246.769 143.914)",
    fill: "none",
    stroke: "#846a6a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M112.1,159.065,88.424,123.7l-7.334,1.531C86.7,144.108,90.4,151.576,90.4,151.576",
    transform: "translate(2.767 4.233)",
    fill: "#ffcbbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2932",
    "data-name": "Path 2932",
    d: "M85.359,131.513l-3.775-5.854s-7.023-1.624-9.578-2.927a10.6,10.6,0,0,1-5-5.534c-.538-1.5-.3-5.9.331-5.958,1.51-.165,4.53,5.461,5.937,5.792s5.979,0,8.492.31a8.275,8.275,0,0,1,6.02,4.53l3.879,7.013",
    transform: "translate(2.273 3.805)",
    fill: "#ffcbbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    d: "M96.605,133.91l-4.158-6.02L81.7,132.71l3.413,9.154",
    transform: "translate(2.788 4.377)",
    fill: "#e6e8ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M189.159,118.467s-17.325-12.319-35.168,2.813c-16.674,14.1-27.772,42.553-31.507,42.553-2.586,0-18.618-20.46-28.207-32.986L82.9,136.941c7.178,21.918,22.828,59.207,46.246,59.207,18.381,0,56.1-43.04,56.1-43.04",
    transform: "translate(2.83 3.891)",
    fill: "#b9b5b2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    y1: 23.283,
    x2: 27.928,
    transform: "translate(157.917 162.987)",
    fill: "none",
    stroke: "#846a6a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M187.24,120.522l16.643,17.832,2.182-20.615",
    transform: "translate(6.414 4.028)",
    fill: "#e6e8ef",
    stroke: "#846a6a",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M200.7,103.01l4.686,10.271s1.883,5.875-5.917,8.544a13.033,13.033,0,0,1-13.8-3l-1.241-16.1",
    transform: "translate(6.318 3.512)",
    fill: "#ffcbbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M185.263,112.64s6.206,7.716,14.253,8.864l-5.875,8.709c-4.768-2.72-10.581-13.064-10.581-13.064Z",
    transform: "translate(6.271 3.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M204.4,111.58a20.873,20.873,0,0,1-5.43,9.961l6.692,5.058c1.541-3.786,1.355-9.682,1.355-9.682Z",
    transform: "translate(6.817 3.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M207.624,87.205s4.417,16.932-2.214,21.2-18.184-2.224-18.846-4.355-3.682-20.191.652-21.546C194.912,80.1,205.369,79.965,207.624,87.205Z",
    transform: "translate(6.335 2.767)",
    fill: "#ffcbbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M206.786,92.332a.861.861,0,1,1-1.034-.641A.861.861,0,0,1,206.786,92.332Z",
    transform: "translate(7.028 3.132)",
    fill: "#173789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M205.4,87.44c.3,0,1.593.176,1.324.817-.124.279-.579.279-.827.259a2.2,2.2,0,0,0-.786,0,1.169,1.169,0,0,1,.165.269c.072.186-.569.207-.641.207a3.548,3.548,0,0,0-2.182.4A2.886,2.886,0,0,1,205.4,87.44Z",
    transform: "translate(6.937 2.987)",
    fill: "#173789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M196.45,94.608a.848.848,0,0,0,.91.807.825.825,0,1,0-.91-.807Z",
    transform: "translate(6.731 3.204)",
    fill: "#173789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    d: "M194.035,91.327c-.631.341-1.148.8-1.034,1.314s.517.3.765.1a4.686,4.686,0,0,1,1.417-.755.941.941,0,0,0-.341.776,3.662,3.662,0,0,0,3.186-3.165,5.989,5.989,0,0,1-1.2.838C195.928,90.852,194.914,90.841,194.035,91.327Z",
    transform: "translate(6.612 3.061)",
    fill: "#173789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    d: "M202.657,93.29s2.348,5.906,1.469,6.454-3.8.445-3.8.445",
    transform: "translate(6.864 3.188)",
    fill: "none",
    stroke: "#ef977f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M203.079,108.519a13.54,13.54,0,0,1-12.63-2.069",
    transform: "translate(6.525 3.64)",
    fill: "none",
    stroke: "#ef977f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M199,104.7s.6-2.617,4.9-2.617",
    transform: "translate(6.818 3.49)",
    fill: "none",
    stroke: "#ef977f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M211.549,78.378a3.6,3.6,0,0,0-.755-2.245,3.465,3.465,0,0,0-2.576-.817,15.588,15.588,0,0,0-9.123,2.907l2.172-1.883c.569-.5,1.851-1.283,1.231-2.2s-2.069-.352-2.865-.362c-3.7,0-7.241,1.272-10.685,2.576a27.659,27.659,0,0,0-4.893,2.265,9.309,9.309,0,0,0-3.61,3.92,11.181,11.181,0,0,0-.755,4.634,56.744,56.744,0,0,0,.91,8.451c.486,3.1,1.21,9.082,5.317,9.444a3.351,3.351,0,0,0,2.317-.352,2.917,2.917,0,0,0,.952-2.069,10.613,10.613,0,0,0-.238-3.827c.765.424,1.5,1.117,2.358,1.034a.8.8,0,0,0,.672-.465,1.1,1.1,0,0,0,0-.548c-.321-2.927-.5-5.834-.683-8.771q6.3-1.334,12.671-2.3c1.883-.279,3.868-.59,5.327-1.81C211.424,84.16,211.776,81.088,211.549,78.378Z",
    transform: "translate(6.154 2.512)",
    fill: "#173789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    d: "M189.687,99.169c-.693-1.727-1.914-3.8-3.817-2.627a3.672,3.672,0,0,0-1.314,2.151c-.879,2.834,1.158,7.24,3.951,6.816,1.365-.2,2.069-1.81,2.669-3.1",
    transform: "translate(6.315 3.288)",
    fill: "#ffcbbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    d: "M434.67,278.834a33.679,33.679,0,0,1,22.156-31.775c2.4-.89,13.912-1.758,13.912-1.758s-1.345,8.782-3.641,13.209c-5.337,10.344-15.908,19-32.427,20.325",
    transform: "translate(14.915 8.41)",
    fill: "#8ebca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2950",
    "data-name": "Path 2950",
    d: "M467.39,303.4a28.021,28.021,0,0,1,35.716-6.558.8.8,0,0,1,.434.445.776.776,0,0,1-.29.672,26.014,26.014,0,0,1-21.628,8.42A94.31,94.31,0,0,1,467.39,303.4",
    transform: "translate(16.039 10.052)",
    fill: "#a2ccb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2951",
    "data-name": "Path 2951",
    d: "M476.33,290.392c0-8.037,2.679-15.246,7.4-19.963a22.2,22.2,0,0,1,18.618-6.061,1.034,1.034,0,0,1,.693.29,1.314,1.314,0,0,1,.217.921c-.414,9.671-5.254,17.677-12.65,20.894a73.926,73.926,0,0,1-14.264,3.92",
    transform: "translate(16.346 9.058)",
    fill: "#8ebca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2952",
    "data-name": "Path 2952",
    d: "M488.39,276.306a68.041,68.041,0,0,1,11.481-13.922,28.9,28.9,0,0,1,5.792-4.355c6.92-3.724,15.464-2.565,22.9-.052-2.958,5.617-6.816,11.119-12.5,13.964a34.248,34.248,0,0,1-8.006,2.555c-5.451,1.21-14.14,1.1-19.653,1.81",
    transform: "translate(16.761 8.766)",
    fill: "#a2ccb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2953",
    "data-name": "Path 2953",
    d: "M485.111,263.917c-13.84-7.241-15.888-22.373-16.239-27.928-.217-3.506,0-7.406,2.927-9.93,17.16,6.041,21.535,17.646,13.312,37.9",
    transform: "translate(16.088 7.749)",
    fill: "#8ebca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2954",
    "data-name": "Path 2954",
    d: "M427.674,261.771c1.034-7.365,2.069-15.277-1.283-21.928a26.357,26.357,0,0,0-4.768-6.392c-4.5-4.634-10.4-8.451-16.85-8.451a29.427,29.427,0,0,0,20,32.893",
    transform: "translate(13.874 7.713)",
    fill: "#8ebca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2955",
    "data-name": "Path 2955",
    d: "M466.5,308.462a29.914,29.914,0,0,1-18.246-39.574,1.262,1.262,0,0,1,.662-.817,1.283,1.283,0,0,1,.962.238c11.947,6.868,20.108,26.831,16.622,40.154",
    transform: "translate(15.307 9.192)",
    fill: "#a2ccb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2956",
    "data-name": "Path 2956",
    d: "M434.5,269.1a29.252,29.252,0,0,1,13.447-35.168c2.42-1.345,5.068-2.358,7.241-4.137a67.237,67.237,0,0,1,1.469,9.837,28.723,28.723,0,0,1-.621,9.775c-2.255,8.182-9.8,13.736-17.367,17.584",
    transform: "translate(14.854 7.878)",
    fill: "#a2ccb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2957",
    "data-name": "Path 2957",
    d: "M425.922,267.213c-12.412,1.51-27.731-3.506-34.372-15.215,21.246-10.809,34.372,5.72,34.372,15.215",
    transform: "translate(13.434 8.519)",
    fill: "#a2ccb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2958",
    "data-name": "Path 2958",
    d: "M433.315,294.112c-2.793-9.537-10.126-17.367-18.96-20.232a27.121,27.121,0,0,0-26.066,5.658,1.345,1.345,0,0,0-.59,1.034,1.324,1.324,0,0,0,.29.662c4.748,6.868,12.33,10.923,20.077,12.629s15.753,1.3,23.645.714",
    transform: "translate(13.301 9.351)",
    fill: "#a2ccb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2959",
    "data-name": "Path 2959",
    d: "M416.353,244.207a52.628,52.628,0,0,1,11.016,16.881,138.987,138.987,0,0,1,6.734,20.687,303.948,303.948,0,0,1,7.52,45.336c.869,8.564,1.427,17.16,2.4,25.714,0,.279.455.29.445,0-.331-7.768-1.034-15.515-1.789-23.273s-1.645-15.381-2.813-23.025-2.617-15.288-4.5-22.818a148.221,148.221,0,0,0-6.589-20.811c-2.886-6.972-6.692-13.654-12.247-18.856-.145-.124-.352.083-.207.217Z",
    transform: "translate(14.283 8.366)",
    fill: "#597f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2960",
    "data-name": "Path 2960",
    d: "M440.133,301.852c-3.672-6.061-9.454-10.209-15.691-13.3a76.3,76.3,0,0,0-22.011-7,55.73,55.73,0,0,0-12.785-.734.186.186,0,0,0,0,.372c3.837.186,7.654.31,11.461.848a75.737,75.737,0,0,1,21.5,6.382,51.057,51.057,0,0,1,9.082,5.172,36.141,36.141,0,0,1,7.975,8.523c.186.259.61,0,.445-.259Z",
    transform: "translate(13.362 9.627)",
    fill: "#597f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2961",
    "data-name": "Path 2961",
    d: "M434.839,284.941c0-5.71-.579-11.378-.072-17.119a46.04,46.04,0,0,1,4.137-15.515,51.463,51.463,0,0,1,4.541-7.478c.114-.165-.134-.352-.269-.207a26.738,26.738,0,0,0-4.365,6.485,44.332,44.332,0,0,0-2.875,7.344A53.6,53.6,0,0,0,434,274.846c.072,3.362.238,6.754.6,10.1a.124.124,0,0,0,.238,0Z",
    transform: "translate(14.891 8.385)",
    fill: "#597f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2962",
    "data-name": "Path 2962",
    d: "M406.921,255.743c3.786.393,7.241,2.524,10.344,4.675a102.683,102.683,0,0,1,10.219,8.606c1.686,1.541,3.31,3.176,5.079,4.624.166.134.393-.083.238-.238-3.1-3.1-6.372-6.01-9.682-8.833a49.451,49.451,0,0,0-10.644-7.354,15.908,15.908,0,0,0-5.523-1.583.052.052,0,1,0,0,.1Z",
    transform: "translate(13.961 8.766)",
    fill: "#597f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2963",
    "data-name": "Path 2963",
    d: "M461.153,326.931a91.712,91.712,0,0,1,4.748-17.139,82.845,82.845,0,0,1,8.275-15.66A84.972,84.972,0,0,1,499.5,269.6a79.913,79.913,0,0,1,8.73-4.737c3.051-1.417,6.206-2.524,9.309-3.7a.251.251,0,0,0-.124-.486,53.59,53.59,0,0,0-8.357,3.1,79.893,79.893,0,0,0-8,4.137,84.485,84.485,0,0,0-14.336,10.675,85.563,85.563,0,0,0-20.542,29.086,70.232,70.232,0,0,0-5.41,19.208c0,.207.341.259.383.052Z",
    transform: "translate(15.812 8.938)",
    fill: "#597f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2964",
    "data-name": "Path 2964",
    d: "M477.392,237.361c5.544,11.533,8.844,25.125,6.289,37.878A44.9,44.9,0,0,1,480,285.779a.271.271,0,0,0,.465.279c3.5-5.7,4.789-12.774,4.81-19.374a61.657,61.657,0,0,0-3.4-19.777,72.739,72.739,0,0,0-4.137-9.764c-.124-.248-.486,0-.372.217Z",
    transform: "translate(16.381 8.127)",
    fill: "#597f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2965",
    "data-name": "Path 2965",
    d: "M488.692,315v12.123c0,48.046-12.661,61.72-12.661,61.72H436.86s-12.65-13.674-12.65-61.72V315Z",
    transform: "translate(14.556 10.805)",
    fill: "#f2f5f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    y1: 159.281,
    x2: 33.213,
    transform: "translate(82.595 240.378)",
    fill: "none",
    stroke: "#544943",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x1: 33.224,
    y1: 159.281,
    transform: "translate(115.809 240.378)",
    fill: "none",
    stroke: "#544943",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    y1: 159.281,
    x2: 33.224,
    transform: "translate(418.11 240.378)",
    fill: "none",
    stroke: "#544943",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x1: 33.213,
    y1: 159.281,
    transform: "translate(451.333 240.378)",
    fill: "none",
    stroke: "#544943",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 396.8,
    height: 9.526,
    transform: "translate(83.671 230.841)",
    fill: "#e7eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2966",
    "data-name": "Path 2966",
    d: "M450.79,208.962H310.6a4,4,0,0,1-3.951-4.717l16.1-90.63a6.02,6.02,0,0,1,5.927-4.955H468.9a4.013,4.013,0,0,1,3.962,4.717l-16.115,90.63a6,6,0,0,1-5.958,4.955Z",
    transform: "translate(10.515 3.716)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2967",
    "data-name": "Path 2967",
    d: "M453.981,208.962H313.753a4,4,0,0,1-3.951-4.717l16.1-90.63a6.02,6.02,0,0,1,5.927-4.955H472.051a4.013,4.013,0,0,1,3.962,4.717L459.9,204.007a6,6,0,0,1-5.917,4.955Z",
    transform: "translate(10.623 3.716)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2968",
    "data-name": "Path 2968",
    d: "M427.015,207.554H346.077a2.317,2.317,0,0,1-2.286-2.72l9.309-52.349a3.486,3.486,0,0,1,3.424-2.865h80.99a2.327,2.327,0,0,1,2.286,2.731l-9.309,52.338A3.455,3.455,0,0,1,427.015,207.554Z",
    transform: "translate(11.792 5.123)",
    fill: "#8e9db2",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2969",
    "data-name": "Path 2969",
    d: "M428.887,207.554H347.9a2.327,2.327,0,0,1-2.286-2.72l9.309-52.349a3.486,3.486,0,0,1,3.424-2.865h80.99a2.327,2.327,0,0,1,2.286,2.731l-9.309,52.338a3.475,3.475,0,0,1-3.424,2.865Z",
    transform: "translate(11.854 5.123)",
    fill: "#c6d2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 32.872,
    height: 30.782,
    transform: "translate(389.923 181.895)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2970",
    "data-name": "Path 2970",
    d: "M408.031,175.87H377v8.844l8.461,35.106h32.913Zm-7.954,34.589c-3.682,0-7.582-4.3-8.7-9.6s.952-9.6,4.634-9.6,7.582,4.3,8.7,9.6-1,9.6-4.686,9.6Z",
    transform: "translate(12.934 6.025)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2971",
    "data-name": "Path 2971",
    d: "M359.625,218.36h73.636v5H354.65a5,5,0,0,1,4.975-5Z",
    transform: "translate(12.166 7.485)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 58.865,
    height: 4.996,
    transform: "translate(386.562 225.845)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2972",
    "data-name": "Path 2972",
    d: "M409.882,175.87H377l10.344,43.95h32.893Zm-8.058,34.589c-3.682,0-7.582-4.3-8.7-9.6s.962-9.6,4.644-9.6,7.572,4.3,8.7,9.6S405.486,210.459,401.825,210.459Z",
    transform: "translate(12.934 6.025)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2483",
    "data-name": "Group 2483",
    transform: "translate(344.06 121.292)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2973",
    "data-name": "Path 2973",
    d: "M334.6,117.28l-1.955,10.964H334.6l1.945-10.964Z",
    transform: "translate(-332.65 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2974",
    "data-name": "Path 2974",
    d: "M340.055,117.28,338.1,128.244h1.955L342,117.28Z",
    transform: "translate(-332.463 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2975",
    "data-name": "Path 2975",
    d: "M345.5,117.28l-1.955,10.964H345.5l1.945-10.964Z",
    transform: "translate(-332.276 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2976",
    "data-name": "Path 2976",
    d: "M350.945,117.28,349,128.244h1.945L352.9,117.28Z",
    transform: "translate(-332.088 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2977",
    "data-name": "Path 2977",
    d: "M356.395,117.28l-1.945,10.964h1.945l1.955-10.964Z",
    transform: "translate(-331.901 -117.28)",
    fill: "#8e9db2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2484",
    "data-name": "Group 2484",
    transform: "translate(418.048 121.292)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2978",
    "data-name": "Path 2978",
    d: "M406.125,117.28l-1.945,10.964h1.945l1.955-10.964Z",
    transform: "translate(-404.18 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2979",
    "data-name": "Path 2979",
    d: "M411.855,117.28l-1.945,10.964h1.945l1.955-10.964Z",
    transform: "translate(-403.983 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2980",
    "data-name": "Path 2980",
    d: "M417.585,117.28l-1.945,10.964h1.945l1.945-10.964Z",
    transform: "translate(-403.786 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2981",
    "data-name": "Path 2981",
    d: "M423.315,117.28l-1.955,10.964h1.955l1.945-10.964Z",
    transform: "translate(-403.59 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2982",
    "data-name": "Path 2982",
    d: "M429.035,117.28l-1.945,10.964h1.945l1.955-10.964Z",
    transform: "translate(-403.393 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2983",
    "data-name": "Path 2983",
    d: "M434.765,117.28l-1.945,10.964h1.945l1.945-10.964Z",
    transform: "translate(-403.196 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2984",
    "data-name": "Path 2984",
    d: "M440.495,117.28l-1.945,10.964h1.945l1.945-10.964Z",
    transform: "translate(-402.999 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2985",
    "data-name": "Path 2985",
    d: "M446.215,117.28l-1.945,10.964h1.945l1.955-10.964Z",
    transform: "translate(-402.803 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2986",
    "data-name": "Path 2986",
    d: "M451.945,117.28,450,128.244h1.945l1.945-10.964Z",
    transform: "translate(-402.606 -117.28)",
    fill: "#8e9db2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2987",
    "data-name": "Path 2987",
    d: "M457.675,117.28l-1.945,10.964h1.945l1.945-10.964Z",
    transform: "translate(-402.409 -117.28)",
    fill: "#8e9db2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2485",
    "data-name": "Group 2485",
    transform: "translate(192.214 177.464)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2988",
    "data-name": "Path 2988",
    d: "M189.108,200.138a2.389,2.389,0,0,0,1.283-.693c.765-1.034-.507-2.193-1.334-2.72-1.034-.683-2.524-.91-3.041-2.214-.579-1.479.424-3.1,1.645-3.91a16.828,16.828,0,0,1,3.372-1.448,6.548,6.548,0,0,0,3.248-2.451c.931-1.489.745-3.424.869-5.11.476-6.6,7.241-9.868,12.909-10,2.844-.072,7.189.952,9.082,3.1a5.72,5.72,0,0,1,1.293,2.586,4.665,4.665,0,0,1-1.262,3.972,43.437,43.437,0,0,1-3.382,2.772c-1.107,1.034-.321,2.131-.569,3.372a4.058,4.058,0,0,1-2.4,2.627c-2.524,1.407-5.492,1.758-8.275,2.524a6.527,6.527,0,0,0-2.41,1.034,13.27,13.27,0,0,0-2.069,2.731,8.575,8.575,0,0,1-5.172,3.31",
    transform: "translate(-185.847 -171.587)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2989",
    "data-name": "Path 2989",
    d: "M204.43,215.777H199v-2.565h5.389a3.165,3.165,0,0,0,3.155-3.155V205.63a3.165,3.165,0,0,0-3.155-3.155H199V199.91h5.389a5.73,5.73,0,0,1,5.73,5.72v4.427a5.73,5.73,0,0,1-5.689,5.72Z",
    transform: "translate(6.818 6.851)",
    fill: "#e8eaef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2990",
    "data-name": "Path 2990",
    d: "M181.911,196.38h21.721v19.953a6.33,6.33,0,0,1-6.33,6.33H188.21a6.33,6.33,0,0,1-6.33-6.33V196.38Z",
    transform: "translate(6.23 6.73)",
    fill: "#e8eaef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2991",
    "data-name": "Path 2991",
    d: "M178.51,218.25s.207,5.11,8.161,5.11h12.474c7.954,0,8.161-5.11,8.161-5.11Z",
    transform: "translate(6.114 7.481)",
    fill: "#c6d2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 115.103,
    height: 2.048,
    transform: "translate(244.369 228.803)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 8.244,
    height: 1.645,
    transform: "translate(248.299 227.148)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 8.244,
    height: 1.645,
    transform: "translate(260.784 227.148)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 8.244,
    height: 1.645,
    transform: "translate(273.269 227.148)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 8.244,
    height: 1.645,
    transform: "translate(285.753 227.148)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 8.244,
    height: 1.645,
    transform: "translate(298.248 227.148)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 8.244,
    height: 1.645,
    transform: "translate(310.733 227.148)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 8.244,
    height: 1.645,
    transform: "translate(323.218 227.148)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 8.244,
    height: 1.645,
    transform: "translate(335.703 227.148)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 8.244,
    height: 1.645,
    transform: "translate(348.187 227.148)",
    fill: "#475577"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 115.103,
    height: 2.048,
    transform: "translate(245.869 228.803)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 8.244,
    height: 1.645,
    transform: "translate(249.81 227.148)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 8.244,
    height: 1.645,
    transform: "translate(262.294 227.148)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 8.244,
    height: 1.645,
    transform: "translate(274.779 227.148)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 8.244,
    height: 1.645,
    transform: "translate(287.264 227.148)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 8.244,
    height: 1.645,
    transform: "translate(299.748 227.148)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 8.244,
    height: 1.645,
    transform: "translate(312.233 227.148)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 8.244,
    height: 1.645,
    transform: "translate(324.718 227.148)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 8.244,
    height: 1.645,
    transform: "translate(337.213 227.148)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 8.244,
    height: 1.645,
    transform: "translate(349.697 227.148)",
    fill: "#c0ccd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2992",
    "data-name": "Path 2992",
    d: "M80.083,298.905a25.135,25.135,0,0,0-14.129-29.086c-2.182-.972-4.52-1.645-6.5-2.989a58.812,58.812,0,0,0-.528,8.533,25.124,25.124,0,0,0,1.262,8.275c2.524,6.837,9.392,11.037,16.157,13.747",
    transform: "translate(2.006 9.15)",
    fill: "#8ebca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2993",
    "data-name": "Path 2993",
    d: "M80.523,316.83c.124-5.172,0-10.457-.341-15.629a38.57,38.57,0,0,0-1.034-6.806,39.3,39.3,0,0,0-2.948-7.851,25.714,25.714,0,0,0-5.71-7.892.176.176,0,0,0-.248.248,42.409,42.409,0,0,1,4.924,6.992A40.97,40.97,0,0,1,78.4,293.96c1.376,4.706,1.4,9.806,1.541,14.678.083,2.72.062,5.472.321,8.192a.124.124,0,0,0,.238,0Z",
    transform: "translate(2.393 9.555)",
    fill: "#597f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2994",
    "data-name": "Path 2994",
    d: "M64.972,333.156a29.448,29.448,0,0,0-11.75-19.87A29.169,29.169,0,0,0,42.63,308.5c-2.141-.486-12.04,0-12.04,0s2.069,7.344,4.53,10.861c5.679,8.213,15.629,14.481,29.852,13.778",
    transform: "translate(1.032 10.574)",
    fill: "#8ebca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2995",
    "data-name": "Path 2995",
    d: "M56.128,308.815a55.349,55.349,0,0,0-2.545-13.984,23.179,23.179,0,0,0-2.286-5.172c-3.269-5.172-9.392-7.623-15.277-8.689-.072,5.006.507,10.281,3.258,14.4a26.955,26.955,0,0,0,4.417,4.789c3.2,2.9,9.04,6.1,12.474,8.689",
    transform: "translate(1.219 9.636)",
    fill: "#a2ccb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2996",
    "data-name": "Path 2996",
    d: "M87.789,292.208c-.921-6.33-1.769-13.126,1.107-18.836a22.756,22.756,0,0,1,4.137-5.482c3.868-3.982,8.926-7.24,14.481-7.24a25.569,25.569,0,0,1-3.331,17.336c-3.1,5.172-10.633,12.412-16.353,14.264",
    transform: "translate(2.968 8.938)",
    fill: "#a2ccb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2997",
    "data-name": "Path 2997",
    d: "M77.94,327.347a22.073,22.073,0,0,0,26.335-18.484.7.7,0,0,0-.817-.972c-10.178-.052-22.756,9.661-25.518,19.456",
    transform: "translate(2.659 10.56)",
    fill: "#a2ccb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2998",
    "data-name": "Path 2998",
    d: "M57.786,305.391c8.378-4.737,13.747-14.16,13.922-24.39-6.051-.331-10.6,3.393-13.24,6.6-3.672,4.468-3.982,12.309-.683,17.832",
    transform: "translate(1.888 9.636)",
    fill: "#a2ccb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2999",
    "data-name": "Path 2999",
    d: "M63.634,321.454a18.515,18.515,0,0,1,17.088-25.4.8.8,0,0,1,.683.227.858.858,0,0,1,.1.424c.228,5.172-2.069,10.168-5.286,14.171S68.8,318,64.606,320.989",
    transform: "translate(2.122 10.154)",
    fill: "#a2ccb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3000",
    "data-name": "Path 3000",
    d: "M97.437,276.933a43.712,43.712,0,0,0-9.754,14.346,114.959,114.959,0,0,0-5.875,17.45,254.667,254.667,0,0,0-6.62,39.161c-.776,7.468-1.489,14.988-1.758,22.487,0,.3.4.279.445,0,.786-6.578,1.221-13.2,1.852-19.8s1.376-13.105,2.369-19.653,2.172-12.857,3.713-19.2a139.2,139.2,0,0,1,5.482-17.946A47.394,47.394,0,0,1,97.634,277.1c.134-.134-.072-.341-.217-.207Z",
    transform: "translate(2.504 9.494)",
    fill: "#597f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3001",
    "data-name": "Path 3001",
    d: "M63.606,329.667c0-1.158-.093-2.317-.062-3.486a36.74,36.74,0,0,1,.341-3.972,37.421,37.421,0,0,1,.693-3.693,33.408,33.408,0,0,0,.848-3.331.193.193,0,0,0-.352-.093,10.219,10.219,0,0,0-1.179,3.341,40.339,40.339,0,0,0-1.034,7.747,14.037,14.037,0,0,0,.217,3.548.259.259,0,0,0,.5-.062Z",
    transform: "translate(2.14 10.805)",
    fill: "#597f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3002",
    "data-name": "Path 3002",
    d: "M64.485,287.82a19.042,19.042,0,0,0-5.058,8.482,34.516,34.516,0,0,0-1.707,11.916,22.539,22.539,0,0,0,1.086,6.682.166.166,0,0,0,.321-.083,34.516,34.516,0,0,1-.807-11.7,31.383,31.383,0,0,1,3.1-10.9,15.6,15.6,0,0,1,3.1-4.272.055.055,0,1,0-.072-.083Z",
    transform: "translate(1.964 9.871)",
    fill: "#597f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3003",
    "data-name": "Path 3003",
    d: "M67.344,359.562a100.259,100.259,0,0,0-.641-13.3,134.287,134.287,0,0,0-2.069-13.736,94.7,94.7,0,0,0-9.506-26.562,67.806,67.806,0,0,0-4.137-6.589,39.967,39.967,0,0,0-5.006-6.02.249.249,0,0,0-.352.352c1.469,1.82,3,3.558,4.386,5.451a65.359,65.359,0,0,1,3.786,5.782,81.5,81.5,0,0,1,5.968,12.723,115.735,115.735,0,0,1,6.206,27.079c.569,4.934.714,9.868,1.034,14.822a.2.2,0,0,0,.393,0Z",
    transform: "translate(1.547 10.059)",
    fill: "#597f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3004",
    "data-name": "Path 3004",
    d: "M101.539,337.7v8.275c0,32.779-10.861,42.109-10.861,42.109H57.021S46.16,378.774,46.16,345.975V337.7Z",
    transform: "translate(1.567 11.585)",
    fill: "#f2f5f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x2: 527.987,
    transform: "translate(29.243 399.658)",
    fill: "none",
    stroke: "#475577",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Illustration);
export default __webpack_public_path__ + "static/media/404 Illustration.63cb6dea83103dcb73fbeccfd08f5760.svg";
export { ForwardRef as ReactComponent };